import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import DetectorController from '../../../controller/DetectorController';
import '../../../styles/CustomModal.css';
import AddMapping from './AddMapping';
type MappingListType = {
  ad_started_at: string;
  address: string;
  distance: number;
  status: number;
  store_id: number;
  store_name: string;
  store_type: number;
  user_id: number;
};
type SearchDataType = { store_id: number; user_id: number; store_name: string; store_type: number };

const StoreMapping = () => {
  const navigate = useNavigate();
  const [storeName, setStoreName] = useState<string>('');
  const [selectStore, setSelectStore] = useState<any>(null);
  const [searchStoreList, setSearchStoreList] = useState<SearchDataType[]>([]);
  const [mappingList, setMappinglList] = useState<MappingListType[]>([]);
  
  const handleStoreNameChange = (e: any) => {
    setStoreName(e.target.value);
  };

  const storeSelect = (data: any) => {
    setSelectStore(data);
    setStoreName('');
    setSearchStoreList([]);
  };

  const getStoreByName = async (storeName: string) => {
    try {
      const oData = {
        store_name: storeName,
      };

      const response = await DetectorController.getStoreByName(oData);

      if (response && response.data) {
        setSearchStoreList(response.data.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const getMappingStore = async () => {
    try {
      const oParams = {
        store_id: selectStore.store_id,
        user_id: selectStore.user_id,
        store_type: selectStore.store_type,
      };
      const response = await DetectorController.getMappingStore(oParams);

      if (response && response.data && response.data.data) {
        setMappinglList(response.data.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const mappingProps = { selectStore, mappingList, getMappingStore };

  useEffect(() => {
    if (selectStore !== null) {
      getMappingStore();
    }
  }, [selectStore]);
  return (
    <Style>
      <div className="rightContentWrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h2>KNOCKKNOCK 매장 맵핑</h2>
        <div className="listWrap">
          <div className="searchStore flex">
            <input
              value={storeName}
              onChange={handleStoreNameChange}
              type="text"
              placeholder="매장명 또는 호텔명을 검색해주세요."
              onKeyDown={(e) => e.key === 'Enter' && getStoreByName(storeName)}
            />
            <button onClick={() => getStoreByName(storeName)}>검색</button>
          </div>
          {searchStoreList && searchStoreList.length > 0 && (
            <div className="storeListWrap">
              {searchStoreList.map((data, index) => (
                <div onClick={() => storeSelect(data)} key={index} className="storeList flex">
                  <h2>{data.store_name}</h2>
                  <button>선택</button>
                </div>
              ))}
            </div>
          )}

          {selectStore !== null && <AddMapping {...mappingProps} />}
        </div>
      </div>
    </Style>
  );
};

export default StoreMapping;

const Style = styled.div`
  .rightContentWrap {
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 2% 4%;
  }
  .listWrap {
    display: flex;
    flex-direction: column;
  }
  input {
    width: 100%;
    outline: none;
    padding: 10px 12px;
    border: none;
    border-bottom: 1px solid #aaa;
  }
  .css-b62m3t-container {
    width: 60%;
  }
  button {
    padding: 10px 24px;
    border: none;
    outline: none;
    border-radius: 4px;
    color: #fff;
  }
  h3 {
    font-size: 20px;
    font-weight: 400;
  }
  h4 {
    font-size: 18px;
    font-weight: 600;
  }
  p {
    font-size: 18px;
  }
  strong {
    color: #4dd2ae;
  }

  /* listWrap */
  .listWrap {
    margin-top: 30px;
  }
  /* searchStore */
  .searchStore {
    width: 60%;

    button {
      margin-left: 4px;
      white-space: nowrap;
      font-size: 16px;
      font-weight: 500;
      background: #000;
    }
  }

  .selectBoxWrap {
    display: flex;
    width: 100%;
    align-items: center;
    padding-top: 30px;

    button {
      flex: 1;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-size: 14px;
      line-height: 20px;
      color: #555555;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
    }
    button:nth-child(1) {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    button:nth-child(2) {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    button.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }

  /* storeListWrap */
  .storeListWrap {
    margin-top: 10px;
    
  }
  .storeList {
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    justify-content: space-between;
    cursor: pointer;

    h2 {
      padding: 6px 12px;
      font-size: 16px;
      font-weight: 500;
    }
    button {
      background: gray;
    }
  }
  .storeList:hover {
    h2 {
      font-weight: 700;
    }
  }

  /* detailListWrap */
  .detailListWrap {
    margin-top: 30px;

    .content {
      margin: 60px 0;
      h4 {
        margin: 10px 0;
        color: #7a7a7a;
      }
    }
  }

  .dateWrap {
    margin-top: 30px;

    input {
      width: 40%;
    }
    p {
      width: 5%;
      white-space: nowrap;
    }
  }
  .dateWrap > div {
    margin-bottom: 10px;
  }
  .charge {
    p {
      margin-bottom: 16px;
    }
  }

  /* submitButton */
  .submitButton {
    width: 100%;
    background: #000;
    font-size: 18px;
    font-weight: 400;
    padding: 14px 10px;
  }
  .backButton {
    margin: 0;
    padding: 0;
  }
  .currentTime {
    background: gray;
  }

  @media (max-width: 1000px) {
    .storeList,
    .searchStore,
    .css-b62m3t-container,
    .submitButton,
    .selectBoxWrap {
      width: 100%;
    }
    .dateWrap,
    .masterWrap {
      input {
        flex: 1;
        font-size: 14px;
      }
      p {
        min-width: 50px;
      }
    }
  }
`;
